import {
  CaretDownOutlined,
  CaretUpOutlined,
  UserOutlined
} from '@ant-design/icons'
import { Avatar, Flex, Popover, Spin } from 'antd'
import { useTheme } from 'antd-style'
import { useEffect, useState } from 'react'

import { useUserServiceGetUserProfileEndpoint } from 'src/api/queries'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

import { ProfileDetails } from './ProfileDetails'
import { useStyles } from './styles'

export const ProfileCard = () => {
  const palette = useTheme()
  const { styles } = useStyles()
  const { currentLang, onChangeLang } = useLocales()

  const [isOpen, setIsOpen] = useState(false)

  const { data, isLoading } = useUserServiceGetUserProfileEndpoint()

  useEffect(() => {
    if (data?.systemLanguage && data.systemLanguage !== currentLang.value) {
      onChangeLang(data.systemLanguage)
    }
  }, [data])

  const onOpenChange = (newOpen: boolean) => {
    setIsOpen(newOpen)
  }

  return (
    <Spin spinning={isLoading} size="small">
      <Popover
        content={<ProfileDetails data={data} />}
        onOpenChange={onOpenChange}
        open={isOpen}
        arrow={false}
      >
        <Flex gap={16} align="center" className={styles.profileCard}>
          <Avatar icon={<UserOutlined />} />
          <Flex vertical>
            <Text weight={600} color={palette.black.black1}>
              {data?.firstName} {data?.lastName}
            </Text>
          </Flex>

          <div className={styles.arrow}>
            {isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
          </div>
        </Flex>
      </Popover>
    </Spin>
  )
}
